<template>
  <div id="department-field">
    <p
      class="main-department select-box click"
      v-for="department in Object.entries(main_departments as any).slice(0, 8)"
      :key="department[0]"
      :class="{ selected: department[0] == roadbookStore.department }"
      @click="
        selectDepartment({ value: department[0], label: (department[1] as string).toString() })
      "
    >
      {{ department[0] }}
    </p>
    <v-select
      id="client-department-select"
      :options="departments"
      :model-value="selectedDepartment"
      :placeholder="props.placeholder"
      :filter-by="filter"
      @update:model-value="(val) => selectDepartment(val || null)"
    >
      <template #selected-option="option"
        ><span>{{ option.label }}</span></template
      >
      <template #option="option"
        ><span>{{ option.label }} ({{ option.key }})</span></template
      >
      <template #no-options
        ><span>{{ $t('no_results') }}</span></template
      >
    </v-select>
  </div>
</template>

<script setup lang="ts">
  import { FRA_OPTIONS, getFrenchOSM } from '@/services/administrativeDivisions/france.service';
  import { useConfigStore, useRoadbookStore } from '@/store';
  import toKey from '@/utils/toKey';
  import { computed, ref, watch } from 'vue';

  const configStore = useConfigStore();
  const roadbookStore = useRoadbookStore();

  const props = defineProps({
    placeholder: {
      type: String,
      default: null,
    },
  });

  const selectedDepartment = ref(getFrenchOSM(roadbookStore.department)?.aL6 ?? '');

  const main_departments = computed(() => configStore.config.main_departments);
  const departments: { value: string; label: string; key: string }[] = FRA_OPTIONS.map((it) => {
    it['key'] = it.value;
    return it;
  }) as { value: string; label: string; key: string }[];

  watch(
    () => roadbookStore.department,
    () => {
      selectedDepartment.value = getFrenchOSM(roadbookStore.department)?.aL6 ?? '';
    },
  );

  function filter(
    option: { value: string; label: string },
    label: string,
    search: string,
  ): boolean {
    return toKey(`${option.label} ${option.value}`).includes(toKey(search));
  }
  function selectDepartment(department: { value: string; label: string }): void {
    roadbookStore.setRoadbookModifiedDate();
    const osm = getFrenchOSM(department.value);
    const aL4 = osm?.aL4 ?? '';
    roadbookStore.updateMetadata({
      category: 'visitor',
      field: 'department',
      value: department.value,
      skipFields: ['region'],
    });
    roadbookStore.updateMetadata({
      category: 'visitor',
      field: 'region',
      value: toKey(aL4),
      skipFields: ['department'],
    });
  }
</script>

<style lang="postcss">
  #department-field {
    @apply flex flex-wrap items-center;

    .main-department {
      @apply mb-[16px] w-[40px] text-center flex justify-center;
    }

    #client-department-select {
      @apply ml-[8px] mb-[16px] flex-[0];
    }
    .v-select {
      @apply v-select-layer;
      .vs__actions svg path {
        stroke: theme('colors.white') !important;
      }
    }
  }
</style>
